<div class="flex flex-col w-full border border-gray-200 rounded-md">
  <app-page-header>
    <div class="flex flex-row justify-start items-center gap-2 h-10">
      <span>{{ fileName }}</span>
    </div>
    <div class="flex flex-row gap-4">
      <bic-button (onClick)="downloadPdf()" buttonType="white">Herunterladen
        <fa-icon [icon]="faArrowDownToBracket" iconLeft></fa-icon>
      </bic-button>
    </div>
  </app-page-header>

  <div class="p-4 ">
    <ng-container>
      <ngx-extended-pdf-viewer
        [(src)]="url"
        [contextMenuAllowed]="false"
        [disableForms]="true"
        [showBorders]="false"
        [showDownloadButton]="true"
        [showDrawEditor]="false"
        [showFindButton]="false"
        [showHandToolButton]="false"
        [showHighlightEditor]="false"
        [showOpenFileButton]="false"
        [showPagingButtons]="false"
        [showPresentationModeButton]="false"
        [showPrintButton]="false"
        [showPropertiesButton]="false"
        [showRotateButton]="false"
        [showSecondaryToolbarButton]="false"
        [showSidebarButton]="false"
        [showSpreadButton]="false"
        [showStampEditor]="false"
        [showTextEditor]="false"
        [showToolbar]="false"
        [showZoomButtons]="false">
      </ngx-extended-pdf-viewer>
    </ng-container>
  </div>


</div>





